import { PaddiqLogo } from '@kangaroo/ui';

export function Logo({ inverted = false }: { inverted?: boolean }) {
  return (
    <a className="logo" href="/" aria-label="Paddiq home">
      <PaddiqLogo
        variant="header"
        wordmarkColor={inverted ? '#fff' : '#1f2937'}
        wordmarkSize="1.4rem"
      />
    </a>
  );
}
